import { Dialog } from "@angular/cdk/dialog";
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { ExternalUser } from "../../../domain/model/account/externalUser";
import { DropDownModel } from "../../../domain/model/common/dropDownModel";
import { ManagementCompany } from "../../../domain/model/enrollment/managementCompanies";
import { RentalProperty } from "../../../domain/model/properties/rentalProperty";
import { RentalPropertyTaxRepresentativeInfo } from "../../../domain/model/properties/rentalPropertyTaxRepresentativeInfo";
import { TaxRepresentative } from "../../../domain/model/properties/taxRepresentative";
import { CommonServices } from "../../../domain/service/commonService";
import { GooglePlacesService } from "../../../domain/service/GooglePlaceService";
import { PropertyService } from "../../../domain/service/propertyService";
import { AuthenticationService } from "../../../security/auth/authentication.service";
import { ManagementCompanyAddComponent } from "../../register/management-company-add/management-company-add.component";
import { atLeastOneRequiredTrueValidator } from "../../../custom-validators/at-least-one-is-required-true-validator";

const COMPANY_DATA: ManagementCompany[] = [];
@Component({
  selector: "app-properties-detail-reporting",
  templateUrl: "./properties-detail-reporting.component.html",
  styleUrl: "./properties-detail-reporting.component.css",
})
export class PropertiesDetailReportingComponent implements OnInit, OnChanges, OnDestroy {
  externalUser!: ExternalUser | null;
  states: DropDownModel[] = [];
  suggestions: any[] = [];
  @Input() rentalPropertyModel!: RentalProperty;
  @Input() taxRepresentative!: TaxRepresentative;
  @Input() companies!: ManagementCompany[];
  @Output() formChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  public hasChange: boolean = false;
  showTaxRepresentativeForm: boolean = false;
  rentalPropertyReporting!: FormGroup;
  isManager = false;
  isOwner = false;
  hasCompanyChanges = false;
  dialog = inject(Dialog);
  currentCompany: ManagementCompany | undefined;
  
  constructor(
    private propertyService: PropertyService,
    private commonServices: CommonServices,
    private googlePlacesService: GooglePlacesService,
    private readonly auth: AuthenticationService,
    private fb: FormBuilder
  ) {
    this.externalUser = this.auth.getCurrentUser2();
  }
  ngOnDestroy(): void {
    COMPANY_DATA.length = 0;
  }
  ngOnInit(): void {
    this.commonServices.getAllState(233).subscribe((data) => {
      this.states = data.sort((a, b) => a.name.localeCompare(b.name));
    });

    this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.valueChanges.subscribe((value) => {
      if (value) {
        this.googlePlacesService.getPlaces(value).then((predictions: any) => {
          this.suggestions = predictions;
        });
      } else {
        this.suggestions = [];
      }
    });
  }
  managementcompaniesColumns: string[] = [
    "name",
    "streetAddress",
    "aptUnitSuite",
    "city",
    "state",
    "zipCode",
    "action",
  ];
  companyDataSource = new MatTableDataSource(COMPANY_DATA);

  showManager(event: any) {}
  newGuid(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  addCompany() {
    let company: ManagementCompany = {
      companyName: "",
      streetAddress: "",
      aptUnitSuite: "",
      city: "",
      state: 0,
      zipCode: "",
      internalId: this.newGuid(),
      stateName: "",
      id: 0,
      accountId: 0,
      rentalPropertyId: 0,
    };

    const dialogRef = this.dialog.open<ManagementCompany>(ManagementCompanyAddComponent, {
      height: "510px",
      disableClose: true,
      data: { company },
    });

    dialogRef.closed.subscribe((result) => {
      this.currentCompany = result;
      if (result) {
        this.hasCompanyChanges = true;
        result.accountId = this.rentalPropertyModel.accountID;
        result.rentalPropertyId = this.rentalPropertyModel.id;
        COMPANY_DATA.push(result);
        this.companyDataSource = new MatTableDataSource(COMPANY_DATA);
      }
    });
  }
  editCompany(company: ManagementCompany) {
    console.log(company);
    const dialogRef = this.dialog.open<ManagementCompany>(ManagementCompanyAddComponent, {
      width: "500px",
      height: "510px",
      disableClose: true,
      data: { company },
    });

    dialogRef.closed.subscribe((result) => {
      this.currentCompany = result;
      console.log(result);
      if (result) {
        this.hasCompanyChanges = true;
        let index = COMPANY_DATA.findIndex((e) => e.id == result.id);
        COMPANY_DATA[index] = result;
        this.companyDataSource = new MatTableDataSource(COMPANY_DATA);
      }
    });
  }
  removeCompany(index: number) {
    this.hasCompanyChanges = true;
    COMPANY_DATA.splice(index, 1);

    this.companyDataSource = new MatTableDataSource(COMPANY_DATA);
  }
  public showAndHideTaxForm(show: boolean) {
    if (show) {
      this.rentalPropertyReporting.get("taxRepresentativeFirstName")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeFirstName")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeLastName")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeLastName")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeEmail")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeEmail")?.addValidators(Validators.email);
      this.rentalPropertyReporting.get("taxRepresentativeEmail")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativePhoneNumber")?.addValidators(Validators.required);
      this.rentalPropertyReporting
        .get("taxRepresentativePhoneNumber")
        ?.addValidators(
          Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
        );
      this.rentalPropertyReporting.get("taxRepresentativePhoneNumber")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeCity")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeCity")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeState")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeState")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.addValidators(Validators.maxLength(12));
      this.rentalPropertyReporting
        .get("taxRepresentativeZipCode")
        ?.addValidators(Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/));
      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.updateValueAndValidity();
    } else {
      this.rentalPropertyReporting.get("taxRepresentativeFirstName")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeFirstName")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeLastName")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeLastName")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeEmail")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeEmail")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativePhoneNumber")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativePhoneNumber")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeCity")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeCity")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeState")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeState")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.updateValueAndValidity();

      
      this.rentalPropertyReporting.setValidators(atLeastOneRequiredTrueValidator('sendToOwner', 'sendToReportingRep'));
      this.rentalPropertyReporting.updateValueAndValidity();
    }
    this.showTaxRepresentativeForm = show;
    this.rentalPropertyReporting.get("isUsingTaxRepresentative")?.setValue(show);
  }
  async selectPlace(place: any) {
    this.suggestions = [];
    const details = await this.googlePlacesService.getPlaceDetails(place.place_id);
    let selectedZipCode = this.googlePlacesService.extractLocationDetails(details);

    if (selectedZipCode.zip) {
      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.setValue(selectedZipCode.zip);
    }

    if (selectedZipCode.city) {
      this.rentalPropertyReporting.get("taxRepresentativeCity")?.setValue(selectedZipCode.city);
    }

    if (selectedZipCode.stateCode) {
      let stateId = this.states.find((e) => e.iso2 == selectedZipCode.stateCode)?.id ?? 0;
      this.rentalPropertyReporting.get("taxRepresentativeState")?.setValue(stateId);
    }

    if (selectedZipCode.address) {
      this.rentalPropertyReporting?.get("taxRepresentativeStreetAddress")?.setValue(selectedZipCode.address);
      this.rentalPropertyReporting?.get("taxRepresentativeStreetAddress")?.updateValueAndValidity();
      this.rentalPropertyReporting?.get("taxRepresentativeStreetAddress")?.markAsUntouched();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isManager = this.rentalPropertyModel.reportingPropertyManagementCompany;
    this.isOwner = this.rentalPropertyModel.reportingOwner;
    this.showTaxRepresentativeForm = this.rentalPropertyModel.isUsingTaxRepresentative;
    this.buildForm(this.rentalPropertyModel, this.taxRepresentative);
    this.companies.forEach((element) => {
      COMPANY_DATA.push(element);
    });
  }
  private buildForm(info: RentalProperty | undefined, taxReporting: TaxRepresentative | undefined): void {
    this.isManager = info?.reportingOwner?? false;
    this.isOwner = info?.reportingOwner ?? false;
    
    this.rentalPropertyReporting = this.fb.group({
      taxRepresentativeFirstName: [this.taxRepresentative?.firstName ?? ""],
      taxRepresentativeLastName: [this.taxRepresentative?.lastName ?? ""],
      taxRepresentativeEmail: [this.taxRepresentative?.email ?? ""],
      taxRepresentativePhoneNumber: [this.taxRepresentative?.phoneNumber ?? ""],
      taxRepresentativeStreetAddress: [this.taxRepresentative?.streetAddress ?? ""],
      taxRepresentativeAptUnitSuite: [this.taxRepresentative?.aptUnitSuite ?? ""],
      taxRepresentativeCity: [this.taxRepresentative?.city ?? ""],
      taxRepresentativeState: [this.taxRepresentative?.state ?? ""],
      taxRepresentativeZipCode: [this.taxRepresentative?.zipCode ?? ""],
      sendToOwner: [this.rentalPropertyModel?.correspondenceToOwner ?? false],
      sendToReportingRep: [this.rentalPropertyModel?.correspondenceToReportingRepresentative ?? false],
      isUsingTaxRepresentative: [this.rentalPropertyModel?.isUsingTaxRepresentative ?? false],
    });

    this.rentalPropertyReporting.valueChanges.subscribe((newValues) => {
      this.hasChange = true;
      this.formChanged.emit(true);
    });
  }
  public saveTaxInfoRentalProperty() {
    if (
      this.isManager != this.rentalPropertyModel.reportingPropertyManagementCompany ||
      this.isOwner != this.rentalPropertyModel.reportingOwner ||
      this.rentalPropertyReporting.get("sendToReportingRep")?.value !=
        this.rentalPropertyModel.correspondenceToReportingRepresentative ||
      this.rentalPropertyReporting.get("sendToOwner")?.value != this.rentalPropertyModel.correspondenceToOwner ||
      this.rentalPropertyReporting.get("isUsingTaxRepresentative")?.value !=
        this.rentalPropertyModel.isUsingTaxRepresentative
    ) {
      let model: RentalPropertyTaxRepresentativeInfo = {
        rentalPropertyId: this.rentalPropertyModel.id,
        isUsingTaxRepresentative: this.rentalPropertyReporting.get("isUsingTaxRepresentative")?.value,
        correspondenceToOwner: this.rentalPropertyReporting.get("sendToOwner")?.value,
        correspondenceToReportingRepresentative: this.rentalPropertyReporting.get("sendToReportingRep")?.value,
        reportingOwner: this.isOwner,
        reportingPropertyManagementCompany: this.isManager,
      };
      this.propertyService.updateRentalPropertyTaxRepresentativeInfo(model).subscribe({
        next: (response) => {},
        error: (error) => {},
        complete: () => {
          this.formChanged.emit(true);
        },
      });
    }
  }
  private saveCompanies() {
    this.propertyService.updateCompanies(COMPANY_DATA).subscribe({
      next: (response) => {},
      error: (error) => {},
      complete: () => {
        this.formChanged.emit(true);
      },
    });
  }
  public saveTaxRepresentative() {
    let model: TaxRepresentative = {
      id: this.taxRepresentative?.id ?? 0,
      accountId: this.rentalPropertyModel?.accountID,
      firstName: this.rentalPropertyReporting.get("taxRepresentativeFirstName")?.value,
      lastName: this.rentalPropertyReporting.get("taxRepresentativeLastName")?.value,
      email: this.rentalPropertyReporting.get("taxRepresentativeEmail")?.value,
      phoneNumber: this.rentalPropertyReporting.get("taxRepresentativePhoneNumber")?.value,
      streetAddress: this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.value,
      aptUnitSuite: this.rentalPropertyReporting.get("taxRepresentativeAptUnitSuite")?.value,
      city: this.rentalPropertyReporting.get("taxRepresentativeCity")?.value,
      state: this.rentalPropertyReporting.get("taxRepresentativeState")?.value,
      zipCode: this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.value,
      rentalPropertyId: this.rentalPropertyModel.id,
    };

    this.propertyService.updateTaxRepresentative(model).subscribe({
      next: (response) => {},
      error: (error) => {},
      complete: () => {
        this.formChanged.emit(true);
      },
    });
  }

  public save() {
    if (this.hasCompanyChanges) {
      this.saveCompanies();
    }
    this.saveTaxInfoRentalProperty();
    this.saveTaxRepresentative();
  }
}
